import PlanList from './PlanList.vue'
export { PlanList }
export default PlanList
